import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { MovimentoResponse } from "../types";

export default async function getMovimentos(search?: string, numeroNF?: string, movimentoTipo?: string, page: number = 1) {
  const { data } = await api.get<Paginate<MovimentoResponse>>(
    `${URLS.MOVIMENTOS_API}`,
    {
      params: { page, search, numeroNF, movimentoTipo },
    }
  );

  return data;
}

//Retorna todos os dados sem paginar
export async function getAllMovimentos() {
  const data = await api.get(`${URLS.MOVIMENTOS_API}?all=true`).then((resp) => resp?.data.items);

  return data;
}
